<template>
  <div class="the-game">
    <h1 class="the-game__header" v-if="!isUploading">{{ $t('game.header') }}</h1>
    <h1 class="the-game__header" v-if="isUploading">{{ $t('game.uploading') }}</h1>

    <div class="the-game__box">
      <label class="the-game__box__content the-game__box__content--upload" v-if="!isUploading">
        <input type="file" @change="onFileChange($event.target.files)" />

        <div class="the-game__box__button">+</div>

        <p>{{ $t('game.select') }}</p>
      </label>

      <div class="the-game__box__content" v-if="isUploading">
        <p>{{ uploadProgress }}%</p>

        <div class="the-game__bar">
          <div class="the-game__bar__background"></div>
          <div class="the-game__bar__foreground" :style="getBarStyle()"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js';

export default {
  name: 'TheGame',

  data: () => ({
    isUploading: false,
    uploadProgress: 0,
    answer: '',
    attachment: '',
    score: 0,
  }),

  methods: {
    getBarStyle() {
      return {
        width: `${this.uploadProgress}%`,
      }
    },

    async uploadFile(file) {
      const fileUrl = await ApiService.uploadFile(file, ({ loaded, total }) => {
        const uploadProgress = Math.round((loaded / total) * 100);

        this.uploadProgress = uploadProgress;
      });

      return fileUrl;
    },

    async onFileChange([file]) {
      const hasFile = !!file;

      if (!hasFile) { return; }

      this.isUploading = true;
      this.uploadProgress = 0;

      this.attachment = await this.uploadFile(file);

      this.end();
    },

    end() {
      const { answer, attachment, score } = this;

      this.$emit('end', {
        answer,
        attachment,
        score,
      });
    },
  },
};
</script>

<style lang="scss">
.the-game {
  &__header {
    font-size: 31px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
  }

  &__box {
    max-width: 800px;
    margin: 40px auto 0;

    padding: 5px;
    background-color: #ffffff;

    box-shadow: -6.7px 7.4px 17.2px 3.8px rgba(0, 0, 0, 0.17);

    border-radius: 5px;

    &__content {
      overflow: hidden;
      display: block;
      position: relative;
      width: 100%;
      padding-top: 65%;

      background-color: #0e76bc;

      p {
        position: absolute;
        top: 35px;
        left: 0;
        width: 100%;

        font-size: 70px;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
      }


      &--upload {
        cursor: pointer;

        input[type="file"] {
          position: absolute;
          left: -9999px;
        }

        p {
          position: absolute;
          top: auto;
          bottom: 35px;
          left: 0;
          width: 100%;

          font-size: 31px;
          font-weight: bold;
          text-align: center;
          text-transform: uppercase;
        }
      }
    }

    &__button {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 150px;
      height: 150px;

      display: flex;
      align-items: center;
      justify-content: center;

      color: #0e76bc;
      font-size: 100px;
      font-weight: bold;

      border-radius: 50%;
      background-color: #ffffff;

      transform: translate(-50%, -50%);
    }
  }

  &__bar {
    position: absolute;
    bottom: 30px;
    left: 50%;
    width: 90%;
    transform: translateX(-50%);

    &__background,
    &__foreground {
      position: absolute;
      bottom: 0;
      left: 0;

      width: 100%;
      padding-top: 47.6257%;

      background-size: auto 100%;
      background-position: left center;
      background-repeat: no-repeat;
    }

    &__background {
      background-image: url('~@/assets/upload-background.png');
    }

    &__foreground {
      background-image: url('~@/assets/upload-foreground.png');

      transition: width 0.1s linear;
    }
  }
}
</style>
